module.exports = __webpack_public_path__ + "media/brands/jonway-125a9c4d.png";